import axios from "axios";
import router from "../router/index";
import store from "../store";
import Vue from "vue";

//import applicationUserManager from "../Auth/applicationusermanager";

// let base = "http://dlxl.api.amamiya.cn";
//let base = "http://127.0.0.1:8081";
//let base = "http://47.102.138.143:8081";
//袁刚服务器
//let base = "http://101.34.243.251:8081";
//北海诚钢
//let base = "http://113.17.24.14:8081";
//let base = "http://192.168.1.188:8081";

//周巷亿豪
//let base = "http://192.168.0.254:8081";
//奔利
//let base = "http://192.168.1.254:8081";
let base = "http://115.231.205.74:8081";


//浙江宝红建筑工业化生产基地
//let base = "http://192.168.150.20:8081";
//let base = "http://61.153.59.166:8081";

// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://127.0.0.1:8081':'';

//友和
//let base = "http://192.168.0.155:8081";
//let base = "http://218.72.255.186:8081";

//金瑞
//let base = "http://192.168.3.253:8082";
//let base = "http://192.168.3.253:8081";
//let base = "http://122.227.69.222:8081";

//寰龙工程站
//let base = "http://192.168.7.253:8081";
//let base = "http://122.227.108.146:8081";

//肇庆
//let base = "http://192.168.1.254:8081";
//let base = "http://218.15.244.161:8081";
//let base = "http://218.72.255.186:8081";
//虎强
//let base = "http://192.168.111.253:8081";
//let base = "http://39.174.153.17:8081";

//柳州♥祥混凝土有限公司
//let base = "http://192.168.100.253:8081";

//安徽海鹏建设工程有限公司
//let base = "http://192.168.1.253:8081";

//耕读
//let base = "http://192.168.0.252:8081";
//let base = "http://122.227.106.238:8081";

//潜合
//let base = "http://192.168.0.254:8081";
//let base = "http://122.227.106.238:8081";
//安峰
//let base = "http://192.168.1.234:8081";
//let base = "http://183.245.27.57:8081";
// 请求延时
axios.defaults.timeout = 120000;

var storeTemp = store;
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date();
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire));

    if (
      storeTemp.state.token &&
      curTime < expiretime &&
      storeTemp.state.tokenExpire
    ) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + storeTemp.state.token;
    }

    saveRefreshtime();

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 超时请求处理
    var originalRequest = error.config;
    if (
      error.code == "ECONNABORTED" &&
      error.message.indexOf("timeout") != -1 &&
      !originalRequest._retry
    ) {
      Vue.prototype.$message({
        message: "请求超时！",
        type: "error",
      });

      originalRequest._retry = true;
      return null;
    }

    if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date();
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime));
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({
            token: window.localStorage.Token
          }).then(
            (res) => {
              if (res.success) {
                Vue.prototype.$message({
                  message: "refreshToken success! loading data...",
                  type: "success",
                });

                store.commit("saveToken", res.response.token);

                var curTime = new Date();
                var expiredate = new Date(
                  curTime.setSeconds(
                    curTime.getSeconds() + res.response.expires_in
                  )
                );
                store.commit("saveTokenExpire", expiredate);

                error.config.__isRetryRequest = true;
                error.config.headers.Authorization =
                  "Bearer " + res.response.token;
                return axios(error.config);
              } else {
                // 刷新token失败 清除token信息并跳转到登录页面
                ToLogin();
              }
            }
          );
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin();
        }
      }
      // 403 无权限
      if (error.response.status == 403) {
        Vue.prototype.$message({
          message: "失败！该操作无权限",
          type: "error",
        });
        return null;
      }
      // 429 ip限流
      if (error.response.status == 429) {
        Vue.prototype.$message({
          message: "刷新次数过多，请稍事休息重试！",
          type: "error",
        });
        return null;
      }
    }
    return ""; // 返回接口返回的错误信息
  }
);

export const BaseApiUrl = base;

export const Request = axios;

// 登录
export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/login/jwttoken3.0`, {
      params: params
    })
    .then((res) => res.data);
};
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data);
};

export const refreshToken = (params) => {
  return axios
    .get(`${base}/api/login/RefreshToken`, {
      params: params
    })
    .then((res) => res.data);
};

export const saveRefreshtime = (params) => {
  let nowtime = new Date();
  let lastRefreshtime = window.localStorage.refreshtime ?
    new Date(window.localStorage.refreshtime) :
    new Date(-1);
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire));

  let refreshCount = 1; //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
    window.localStorage.refreshtime = lastRefreshtime;
  } else {
    window.localStorage.refreshtime = new Date(-1);
  }
};
const ToLogin = (params) => {
  store.commit("saveToken", "");
  store.commit("saveTokenExpire", "");
  store.commit("saveTagsData", "");
  window.localStorage.removeItem("user");
  window.localStorage.removeItem("NavigationBar");

  if (global.IS_IDS4) {
    //applicationUserManager.login();
  } else {
    router.replace({
      path: "/login",
      query: {
        redirect: router.currentRoute.fullPath
      },
    });

    window.location.reload();
  }
};

export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, {
      params: params
    })
    .then((res) => res.data);
};

export const testapi2 = () => {
  console.log("api is ok.");
};

export const testapi = (pa) => {
  console.log("api is ok.");
};

// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, {
    params: params
  });
};
export const removeUser = (params) => {
  return axios.get(`${base}/api/user/delete`, {
    params: params
  });
};
export const editUser = (params) => {
  return axios.post(`${base}/api/user/put`, params);
};
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params);
};
export const batchRemoveUser = (params) => {
  return axios.get(`${base}/api/Claims/BatchDelete`, params); //没做
};

// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, {
    params: params
  });
};
export const removeRole = (params) => {
  return axios.get(`${base}/api/role/delete`, {
    params: params
  });
};
export const editRole = (params) => {
  return axios.post(`${base}/api/role/put`, params);
};
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params);
};

// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, {
    params: params
  });
};
export const removeModule = (params) => {
  return axios.get(`${base}/api/module/delete`, {
    params: params
  });
};
export const editModule = (params) => {
  return axios.post(`${base}/api/module/put`, params);
};
export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params);
};

// 菜单模块管理
export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, {
    params: params
  });
};
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, {
    params: params
  });
};
export const removePermission = (params) => {
  return axios.get(`${base}/api/permission/delete`, {
    params: params
  });
};
export const editPermission = (params) => {
  return axios.post(`${base}/api/permission/put`, params);
};
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params);
};
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  });
};
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  });
};

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params);
};
export const getNavigationBar = (params) => {
  return axios
    .get(`${base}/api/permission/GetNavigationBar`, {
      params: params
    })
    .then((res) => res.data);
};

// Bug模块管理
export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, {
    params: params
  });
};
export const removeBug = (params) => {
  return axios.get(`${base}/api/TopicDetail/delete`, {
    params: params
  });
};
export const editBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/update`, params);
};
export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params);
};

// 博客模块管理
export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, {
    params: params
  });
};
export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, {
    params: params
  });
};
export const editBlog = (params) => {
  return axios.post(`${base}/api/Blog/update`, params);
};
export const removeBlog = (params) => {
  return axios.get(`${base}/api/Blog/delete`, {
    params: params
  });
};

// 出货单数据
export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, {
    params: params
  });
};

export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, {
    params: params,
  });
};
export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, {
    params: params
  });
};
export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, {
    params: params
  });
};
export const getIds4UsersGrow = (params) => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, {
    params: params
  });
};
export const getActiveUsers = (params) => {
  return axios.get(`${base}/api/Monitor/GetActiveUsers`, {
    params: params
  });
};

// Task管理
export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, {
    params: params
  });
};
export const removeTask = (params) => {
  return axios.get(`${base}/api/TasksQz/delete`, {
    params: params
  });
};
export const editTask = (params) => {
  return axios.post(`${base}/api/TasksQz/put`, params);
};
export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params);
};

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, {
    params: params
  });
};
export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, {
    params: params
  });
};
export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, {
    params: params
  });
};
export const pauseJob = (params) => {
  return axios.get(`${base}/api/TasksQz/PauseJob`, {
    params: params
  });
};
export const resumeJob = (params) => {
  return axios.get(`${base}/api/TasksQz/ResumeJob`, {
    params: params
  });
};

// ids4
export const getAchieveUsers_IS4 = (params) => {
  return axios.get(`${base}/is4api/GetAchieveUsers`, {
    params: params
  });
};

//组织模块管理
export const requestStationInfo = (params) => {
  return axios
    .get(`${base}/api/SysOrg/GetStationInfo`, {
      params: params
    })
    .then((res) => res.data);
};
export const addSysOrgPost = (params) => {
  return Request.post(`${base}/api/SysOrg/Post`, params);
};
export const getSysOrgListPage = (params) => {
  return Request.get(`${base}/api/SysOrg/Get`, {
    params: params
  });
};
export const getSysOrgDeatil = (params) => {
  return Request.get(`${base}/api/SysOrg/Detail`, {
    params: params
  });
};
export const editSysOrg = (params) => {
  return Request.post(`${base}/api/SysOrg/Put`, params);
};
export const removeSysOrg = (params) => {
  return Request.get(`${base}/api/SysOrg/Delete`, {
    params: params
  });
};

export const getSysStationLineListPage = (params) => {
  return Request.get(`${base}/api/SysStationLine/Get`, {
    params: params
  });
};


//出货单柱状图
export const getRequestApiinfoByWeek = (params) => {
  return Request.get(`${base}/api/ProdOutMaster/GetRequesOutMasterByWeek`, {
    params: params,
  });
};
//出货单折线图
export const getAccessApiByDate = (params) => {
  return Request.get(`${base}/api/ProdOutMaster/GetAccessApiByDate`, {
    params: params,
  });
};
//今日计划任务数量、计划方量、生产方量
export const getDayTaskInfo = (params) => {
  return Request.get(`${base}/api/ProdTask/DayTaskInfo`, {
    params: params,
  });
};
//今日耗料
export const getManufactureSubDay = (params) => {
  return Request.get(`${base}/api/Prodmanufacturesub/ManufactureSubDay`, {
    params: params,
  });
};
//工控机库存
export const getPlcStock = (params) => {
  return Request.get(`${base}/api/MatStock/GetPlcStock`, {
    params: params,
  });
};

/**
 * 封Get装导出Excal文件请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function getExportExcel(url, options = {}, title) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
    axios
      .get(url, {
        params: options
      })
    axios({
      method: 'get',
      url: url, // 请求地址
      params: options, // 参数
      responseType: 'blob' // 表明返回服务器返回的数据类型
    }).then(
      response => {
        resolve(response.data)
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = title + Date.parse(new Date()) + '.xls';
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      },
      err => {
        reject(err)
      }
    )
  })
}

/**
 * 封Get装导出Excal文件请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postExportExcel(url, options = {}, title) {
  return new Promise((resolve, reject) => {
    axios.post(url, options, {
      responseType: 'blob'
    })
      .then(response => {
        const blobData = response.data;
        const url = window.URL.createObjectURL(new Blob([blobData]));
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        let fileName = title + Date.parse(new Date()) + '.xls';
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
}